/* eslint-disable */
import { useState, useEffect } from "react";
import { TextField, Button, Box, styled, Modal, Typography, InputAdornment } from "@mui/material";

const BoxWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "25px",
  "& .confirmationText": {
    marginBottom: "20px",
    color: theme.palette.text.primary,
    fontSize: "14px",
    fontWeight: 600,
  },
  "@media screen and (max-width:600px)": {
    width: "90%",
    "& .confirmationText": {
      fontSize: "11px",
      textAlign: "center",
    },
  },

  "& .topContent": {
    marginBottom: "30px",
    "& h4": {
      fontSize: "22px",
      marginBottom: "8px",
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
  },
  "& .BodyContent": {
    marginBottom: "15px",
    "& .MuiFormControl-root": {
      width: "100%",
      "& label": {
        top: "50%",
        transform: "translate(14px, -50%)",
        "&.MuiInputLabel-shrink": {
          top: 0,
          transform: "translate(14px, -9px) scale(0.75)",
        },
      },
      "& input": {
        padding: "12px 15px",
      },
    },
    "& .ColorPickerWrapper": {
      marginTop: "20px",
      marginBottom: "16px",
      "& label": {
        fontSize: "14px",
        marginBottom: "6px",
        color: theme.palette.text.primary,
        fontWeight: 600,
        display: "block",
      },
      "& input": {
        width: "50px",
        height: "50px",
        border: "none",
        cursor: "pointer",
        borderRadius: "5px",
      },
    },
  },
  "& .BtnWrapper": {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    "& button": {
      textTransform: "none",
      borderRadius: "5px",
      padding: "7px 22px",
      width: "100%",
      boxShadow: "none",
      "&:focus": { outline: "none" },
    },
    "& .MuiButton-root": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      "&.OutlineBtn": {
        backgroundColor: "transparent",
        color: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.main}`,
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          color: "#fff",
        },
      },
    },
  },
}));

const PipelineModal = ({ open, onClose, onSubmit, initialData = null, isDelete = false, handleDeletekanban }) => {
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title || "");
    }
  }, [initialData]);

  const handleTitleChange = e => {
    const input = e.target.value;
    const filtered = input.replace(/[^a-zA-Z _-]/g, "").slice(0, 15);
    setTitle(filtered);
  };

  const handleSubmit = () => {
    if (!title.trim()) return;
    onSubmit({ ...initialData, title: title.trim() });
    setTitle("");
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <BoxWrapper>
        {isDelete ? (
          <>
            <Typography className="confirmationText" component="p">
              Are you sure you want to delete this kanban view?
            </Typography>
            <Box className="BtnWrapper">
              <Button onClick={handleDeletekanban}>Delete</Button>
              <Button className="OutlineBtn" onClick={onClose}>
                Cancel
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Box className="topContent">
              <Typography component="h4">{initialData ? "Edit Pipeline" : "Add New Pipeline"}</Typography>
            </Box>
            <Box className="BodyContent">
              <TextField
                label="Title"
                value={title}
                onChange={handleTitleChange}
                InputProps={{
                  endAdornment: <InputAdornment position="end">{`${title.length}/15`}</InputAdornment>,
                }}
                fullWidth
              />
            </Box>
            <Box className="BtnWrapper">
              <Button onClick={handleSubmit}>{initialData ? "Save" : "Add"}</Button>
              <Button className="OutlineBtn" onClick={onClose}>
                Cancel
              </Button>
            </Box>
          </>
        )}
      </BoxWrapper>
    </Modal>
  );
};

export default PipelineModal;
